import { Box } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axiosService from "services/axios";
import useUserStoreV2 from "store/user-store-v2/useUserStoreV2";

export const RedirectPage = () => {
  const { tgUserId, tgUserName } = useUserStoreV2();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirectUrl");
  const tgGroupId = searchParams.get("groupId");
  const hitTime = new Date();
  const messageId = searchParams.get("messageId");

  useEffect(() => {
    async function redirect() {
      if (redirectUrl) {
        await axiosService.updateProjectConversion(
          messageId!,
          tgUserId ? tgUserId.toString() : "",
          tgUserName ? tgUserName : "anonymous",
          tgGroupId!,
          hitTime,
        );
        window.location.href = redirectUrl;
      }
    }
    redirect();
  }, [redirectUrl, tgUserId, tgUserName]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 100000000,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#000000",
      }}
    />
  );
};
